import { DISTRIBUTOR_LOGIN, IS_LOADING, IS_LOADED, SHOW_ERROR, CLEAR_ERROR, REMOVE_TOKEN, DISTRIBUTOR_TOKEN_UPDATE, UPDATE_THEME, SAVE_DISTRIBUTOR_REDIRECT_URL, SAVE_DISTRIBUTOR_USER_TYPE, DISTRIBUTOR_POINT_UPDATE, DISTRIBUTOR_STAMP_UPDATE } from '../actions/type';

const initState = {
    isAuthenticated: false,
    isLoading: false,
    error: null,
    token: localStorage.getItem("laundry-distributor"),
    distributor: null,
    redirectUrl: localStorage.getItem("laundry-distributor-redirect-url"),
    userType: localStorage.getItem("laundry-distributor-user-type")
};

const distributorReducer = (state = initState, action) => {
    switch (action.type) {
        case IS_LOADING:
            return {
                ...state,
                isLoading: true
            };
        case IS_LOADED:
            return {
                ...state,
                isLoading: false
            };
        case SHOW_ERROR:
            return {
                ...state,
                error: action.payload
            };
        case CLEAR_ERROR:
            return {
                ...state,
                error: null
            };
        case DISTRIBUTOR_LOGIN:
            localStorage.setItem("laundry-distributor", action.payload.token);
            return {
                ...state,
                isAuthenticated: true,
                token: action.payload.token,
                distributor: action.payload.distributor
            };
        case SAVE_DISTRIBUTOR_REDIRECT_URL:
            localStorage.setItem("laundry-distributor-redirect-url", action.payload);
            return {
                ...state,
                redirectUrl: action.payload
            };
        case SAVE_DISTRIBUTOR_USER_TYPE:
            localStorage.setItem("laundry-distributor-user-type", action.payload);
            return {
                ...state,
                userType: action.payload
            };
        case REMOVE_TOKEN:
            localStorage.removeItem("laundry-distributor");
            localStorage.removeItem("laundry-distributor-redirect-url");
            localStorage.removeItem("laundry-distributor-user-type");
            return {
                ...state,
                isAuthenticated: false,
                token: null,
                distributor: null,
                redirectUrl: null,
                userType: null
            };
        case DISTRIBUTOR_STAMP_UPDATE:
            return {
                ...state,
                distributor: {
                    ...state.distributor,
                    stamp: action.payload.stamp,
                }
            }
        case DISTRIBUTOR_TOKEN_UPDATE:
            return {
                ...state,
                distributor: {
                    ...state.distributor,
                    token: action.payload.token,
                }
            };
        case DISTRIBUTOR_POINT_UPDATE:
            return {
                ...state,
                distributor: {
                    ...state.distributor,
                    loyalty_point: action.payload.loyalty_point,
                }
            }
        case UPDATE_THEME:
            localStorage.setItem("theme", action.payload.className);
            return {
                ...state,
                distributor: {
                    ...state.distributor,
                    theme: action.payload
                }
            };
        default:
            return state;
    }
};

export default distributorReducer;